<div class="conn-card so-page">
  <app-report-top-filter-bar
    [paraReportName]="'store-overview-report'"
    (filterCallbackFunc)="callbackFuncFromFilter($event)"
    (filterCallbackFuncUpdateFilter)="filterButtonPressed()"
    (exportExcelFn)="exportExcel()"
    (exportPdfFn)="exportPdf()"
    (productSearchFn)="searchProducts($event)"
  ></app-report-top-filter-bar>

  <div class="so-error" *ngIf="errorMessage">{{ errorMessage }}</div>

  <ng-container *ngIf="data; else emptyState">
    <p class="so-period" *ngIf="data.period">
      {{ data.period.startDate | date: 'MMM d, y' }} – {{ data.period.endDate | date: 'MMM d, y' }}
      <span *ngIf="data.period.timeZone">· {{ data.period.timeZone }}</span>
    </p>

    <h6 class="so-section-title">Business Performance</h6>
    <div class="so-cards">
      <div class="so-card">
        <div class="so-card-label">Total Sales</div>
        <div class="so-card-value so-positive">{{ formatMoney(perf.totalSales) }}</div>
        <div class="so-card-hint">Gross sales after discounts, before refunds</div>
        <div class="so-card-meta">Refunds {{ formatMoney(perf.refunds) }} · Net {{ formatMoney(perf.netSales) }}</div>
      </div>
      <div class="so-card">
        <div class="so-card-label">Total COGS (Sold)</div>
        <div class="so-card-value">{{ formatMoney(perf.soldCogs) }}</div>
        <div class="so-card-hint">Cost of products sold</div>
      </div>
      <div class="so-card">
        <div class="so-card-label">Remaining Inventory Cost</div>
        <div class="so-card-value">{{ formatMoney(perf.remainingInventoryCost) }}</div>
        <div class="so-card-hint">Cost of unsold inventory</div>
        <div class="so-card-meta" *ngIf="perf.inventoryAsOf">As of {{ perf.inventoryAsOf | date: 'MMM d, y, h:mm a' }}</div>
      </div>
      <div class="so-card">
        <div class="so-card-label">Gross Profit</div>
        <div class="so-card-value so-positive">{{ formatMoney(perf.grossProfit) }}</div>
        <div class="so-card-hint">Sales − Sold COGS</div>
        <div class="so-card-meta">Margin {{ perf.grossMarginPercent | number: '1.0-1' }}%</div>
      </div>
    </div>

    <h6 class="so-section-title">Sales by Payment Method</h6>
    <div class="so-payments" *ngIf="paymentMethods.length; else noPayments">
      <div class="so-pay-row so-pay-card" *ngFor="let p of paymentMethods; let i = index">
        <div class="so-pay-head">
          <span class="so-pay-name">{{ p.paymentMethod }}</span>
          <span class="so-pay-amount">{{ formatMoney(p.amount) }}</span>
        </div>
        <div class="so-bar">
          <div class="so-bar-fill" [style.width.%]="p.share" [style.background]="barColor(i)"></div>
        </div>
        <div class="so-pay-meta">{{ p.invoiceCount }} invoices · {{ p.share | number: '1.0-1' }}%</div>
      </div>
    </div>
    <ng-template #noPayments>
      <p class="so-empty-inline">No payments in this period.</p>
    </ng-template>

    <h6 class="so-section-title">Top Selling Products</h6>
    <p-table
      *ngIf="topProducts.length; else noProducts"
      class="so-products-table"
      [value]="topProducts"
      [paginator]="topProducts.length > productRows"
      [rows]="productRows"
      [rowsPerPageOptions]="productRowOptions"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
      responsiveLayout="stack"
      breakpoint="768px"
      styleClass="p-datatable-sm p-datatable-striped"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>Product</th>
          <th class="text-right">Qty Sold</th>
          <th class="text-right">Cost</th>
          <th class="text-right">Margin</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-p>
        <tr>
          <td data-label="Product">{{ p.name }}</td>
          <td data-label="Qty Sold" class="text-right">{{ p.qty }}</td>
          <td data-label="Cost" class="text-right">{{ formatMoney(p.cogs) }}</td>
          <td data-label="Margin" class="text-right so-positive">
            {{ p.margin == null ? '-' : (p.margin | number: '1.0-1') + '%' }}
          </td>
        </tr>
      </ng-template>
    </p-table>
    <div class="so-product-cards" *ngIf="topProducts.length">
      <div class="so-product-card" *ngFor="let p of pagedProducts">
        <div class="so-product-name">{{ p.name }}</div>
        <div class="so-product-stats">
          <div>
            <span>Qty Sold</span>
            <strong>{{ p.qty }}</strong>
          </div>
          <div>
            <span>Cost</span>
            <strong>{{ formatMoney(p.cogs) }}</strong>
          </div>
          <div>
            <span>Margin</span>
            <strong class="so-positive">{{ p.margin == null ? '-' : (p.margin | number: '1.0-1') + '%' }}</strong>
          </div>
        </div>
      </div>
      <p-paginator
        *ngIf="topProducts.length > productRows"
        [rows]="productRows"
        [rowsPerPageOptions]="productRowOptions"
        [first]="cardsFirst"
        [totalRecords]="topProducts.length"
        (onPageChange)="onCardsPage($event)"
      ></p-paginator>
    </div>
    <ng-template #noProducts>
      <p class="so-empty-inline">No product sales in this period.</p>
    </ng-template>
  </ng-container>

  <ng-template #emptyState>
    <div class="so-empty" *ngIf="!errorMessage">No data found!</div>
  </ng-template>
</div>
